import { render } from "./referee_decision_modal.vue?vue&type=template&id=397cacbd"
import script from "./referee_decision_modal.vue?vue&type=script&lang=js"
export * from "./referee_decision_modal.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__